import { createFileRoute } from "@tanstack/react-router";
import { feedbackRoute, FeedbackPage } from "@/features/feedback";

export const Route = createFileRoute("/feedback")({
    validateSearch: feedbackRoute.validateSearch,
    head: feedbackRoute.head,
    component: FeedbackPage,
});
